import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SummaryObject } from 'src/app/shared/model/summary-object';
import { ColumnDefinition } from '../../../../model/column-definition';

@Component({
  selector: 'app-summary, [app-summary]',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {

  @Input() columns: ColumnDefinition[];
  @Input() values: SummaryObject;
  @Input() isSummaryLoading: boolean;

  @Output() openSettings: EventEmitter<null> = new EventEmitter();

  isValueExist(name: string): boolean {
    if (this.values) {
      return Object.keys(this.values).includes(name);
    }
    return false;
  }

}
